import { render, staticRenderFns } from "./TgSpecialCardInfoItem.vue?vue&type=template&id=431ca2f9&"
import script from "./TgSpecialCardInfoItem.vue?vue&type=script&lang=js&"
export * from "./TgSpecialCardInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports